import { render, staticRenderFns } from "./LastTwo.vue?vue&type=template&id=d571f24a"
import script from "./LastTwo.vue?vue&type=script&lang=js"
export * from "./LastTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports